import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { IconButton } from "@mui/material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import UnfoldLessIcon from "@mui/icons-material/UnfoldLess";

// Component for sortable table rows
const SortableRow = ({
  id,
  item,
  index,
  editIndex,
  fields,
  props,
  formData,
  handleInputChange,
  handleEdit,
  handleCancel,
  getDynamicTableBodyCells,
  toggleExpandCell,
  expandedCells,
  handleOpenWidgetEditor,
  getFieldHeaders,
  showEditInput,
  getInputFields,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    backgroundColor: index % 2 === 0 ? "#f0f0f0" : "#848587",
    color: index % 2 === 0 ? "#000000" : "#FFFFFF",
    borderBottom: "1px solid #1E2A44",
    marginBottom: editIndex === index ? "25px" : "0",
    marginTop: editIndex === index ? "25px" : "0",
    position: "relative",
    zIndex: editIndex === index ? 2 : isDragging ? 3 : 1,
  };

  return (
    <tr ref={setNodeRef} style={style}>
      {editIndex === index ? (
        <td
          colSpan={
            fields.length === 0 || typeof props.list_subtable !== "undefined"
              ? 3
              : fields.length + 2
          }
          style={{ padding: "0" }}
        >
          <div
            className="edit-form"
            style={{
              padding: "15px",
              backgroundColor: "#202345",
              border: "1px solid #d1d5db",
              borderRadius: "6px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              position: "relative",
              zIndex: 3,
            }}
          >
            {fields.length === 0 ? (
              <form
                className="input-with-add-btn"
                onSubmit={(e) => e.preventDefault()}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "15px",
                }}
              >
                <input
                  name="add_value"
                  className="form-control"
                  value={formData.data.add_value || ""}
                  onChange={handleInputChange}
                  onKeyDown={(e) => {
                    e.key === "Enter" && e.preventDefault();
                  }}
                  style={{
                    width: "100%",
                    maxWidth: "500px",
                    padding: "10px",
                    border: "2px solid #d1d5db",
                    borderRadius: "6px",
                    fontSize: "14px",
                    outline: "none",
                    transition: "border-color 0.2s ease",
                  }}
                  onFocus={(e) => (e.target.style.borderColor = "#3b82f6")}
                  onBlur={(e) => (e.target.style.borderColor = "#d1d5db")}
                />
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    justifyContent: "flex-start",
                  }}
                >
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEdit(e, index);
                    }}
                    className="primary-gradient-btn submit-btn"
                    disabled={!formData.data.add_value}
                    style={{ padding: "5px 15px" }}
                  >
                    Update
                  </button>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleCancel(e);
                    }}
                    className="primary-gradient-btn submit-btn"
                    style={{ padding: "5px 15px" }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            ) : (
              <form onSubmit={(e) => e.preventDefault()}>
                <table
                  style={{
                    width: "100%",
                    maxWidth: "500px",
                    borderCollapse: "collapse",
                  }}
                >
                  <thead>
                    <tr>{getFieldHeaders()}</tr>
                  </thead>
                  <tbody>
                    <tr>{getInputFields()}</tr>
                  </tbody>
                </table>
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    justifyContent: "flex-start",
                    marginTop: "10px",
                  }}
                >
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEdit(e, index);
                    }}
                    className="primary-gradient-btn submit-btn"
                    style={{ padding: "5px 15px" }}
                  >
                    Update
                  </button>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleCancel(e);
                    }}
                    className="primary-gradient-btn submit-btn"
                    style={{ padding: "5px 15px" }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            )}
          </div>
        </td>
      ) : (
        <>
          <td
            style={{
              padding: "8px",
              width: "10%",
              color: index % 2 === 0 ? "#000000" : "#FFFFFF",
              whiteSpace: "normal",
              wordBreak: "break-word",
              maxWidth: "200px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              border: "none",
              position: "relative",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <DragIndicatorIcon
                {...attributes}
                {...listeners}
                style={{
                  cursor: "grab",
                  color: index % 2 === 0 ? "#000000" : "#FFFFFF",
                }}
              />
              <div
                className="tick"
                onClick={(e) => {
                  e.stopPropagation();
                  toggleExpandCell(index, "index");
                }}
                style={{
                  display: "-webkit-box",
                  WebkitLineClamp: expandedCells[`${index}-index`] ? "none" : 3,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  lineHeight: "1.5",
                  maxHeight: expandedCells[`${index}-index`] ? "none" : "4.5em",
                  textAlign: "center",
                  color: index % 2 === 0 ? "#000000" : "#FFFFFF",
                  cursor: "pointer",
                }}
              >
                {index + 1}
              </div>
              {!expandedCells[`${index}-index`] &&
                String(index + 1).length > 50 && (
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleExpandCell(index, "index");
                    }}
                    sx={{
                      position: "absolute",
                      bottom: "0",
                      right: "0",
                      zIndex: 10,
                      backgroundColor: index % 2 === 0 ? "#f0f0f0" : "#848587",
                      padding: "6px",
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor:
                          index % 2 === 0 ? "#e0e0e0" : "#6b6b6b",
                      },
                    }}
                  >
                    <UnfoldMoreIcon
                      sx={{
                        color: index % 2 === 0 ? "#000000" : "#FFFFFF",
                        fontSize: "16px",
                      }}
                    />
                  </IconButton>
                )}
              {expandedCells[`${index}-index`] &&
                String(index + 1).length > 50 && (
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleExpandCell(index, "index");
                    }}
                    sx={{
                      position: "absolute",
                      bottom: "0",
                      right: "0",
                      zIndex: 10,
                      backgroundColor: index % 2 === 0 ? "#f0f0f0" : "#848587",
                      padding: "6px",
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor:
                          index % 2 === 0 ? "#e0e0e0" : "#6b6b6b",
                      },
                    }}
                  >
                    <UnfoldLessIcon
                      sx={{
                        color: index % 2 === 0 ? "#000000" : "#FFFFFF",
                        fontSize: "16px",
                      }}
                    />
                  </IconButton>
                )}
            </div>
          </td>
          {getDynamicTableBodyCells(
            item,
            index,
            toggleExpandCell,
            expandedCells,
            props,
            handleOpenWidgetEditor,
            showEditInput
          )}
        </>
      )}
    </tr>
  );
};

export default SortableRow;
